module.exports = __webpack_public_path__ + "static/media/education_bg.b541e14a.png";